var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('v-app',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }